
import ApiActions from '../../../actions/api';
import Constants from './constants';
import ForgotStore from './forgot/store';
import LoginStore from './home/store';
import LogoutStore from './logout/store';
import NavBarStore from '../store';
import NavBarConstants from '../constants';
import Qs from 'qs';
import ResetStore from './reset/store';
import ConfirmStore from './confirm/store';

class Actions {
  static forgot(data) {

    ApiActions.post(
      '/v1/login/forgot',
      data,
      ForgotStore,
      Constants.FORGOT,
      Constants.FORGOT_RESPONSE
    );
  }

  static async getUserCreds() {

    if (!global.window) {
      return;
    }

    const response = await ApiActions.get(
      '/v1/users/my',
      undefined,
      LoginStore,
      Constants.GET_USER_CREDS,
      Constants.GET_USER_CREDS_RESPONSE,
    );

    if (response.validation.error) {
      return;
    }

    const query = Qs.parse(window.location.search.substring(1));

    if (query.returnUrl && ApiActions.validateReturnURL(query.returnUrl)) {
      window.location.href = query.returnUrl;
    }
    else if (response.data && response.data.roles) {
      if (response.data.roles.admin) {
        Actions.redirectBasedOnAdminCreds();
      } else if (response.data.roles.account) {
        window.location.href = '/account';
      }
    }
  }

  static async redirectBasedOnAdminCreds() {

    const response = await ApiActions.get(
      '/admin/v1/admins/my',
      undefined,
      LoginStore,
      Constants.GET_ADMIN_CREDS,
      Constants.GET_ADMIN_CREDS_RESPONSE,
    );

    if (response.validation.error) {
      return;
    }
    if (response.data && response.data.groups && response.data.groups.root) {
      // default admin login to /admin/users if supported as that is where the admin usually wants to go
      window.location.href = '/admin/users';
    } else {
      // otherwise fallback to generic admin dashboard
      window.location.href = '/admin';
    }
  }

  static async login(data) {

    const response = await ApiActions.post(
      '/v1/login',
      data,
      LoginStore,
      Constants.LOGIN,
      Constants.LOGIN_RESPONSE,
    );

    if (response.validation.error) {
      window.dataLayer && window.dataLayer.push({
        'event': 'customEvent',
        'eventCategory': 'login',
        'eventAction': 'fail',
        // 'eventLabel': data && data.email // Removed for Google Analytics rules
      });

      return;
    }

    window.dataLayer && window.dataLayer.push({
      'event': 'customEvent',
      'eventCategory': 'login',
      'eventAction': 'success',
      // 'eventLabel': data && data.email // Removed for Google Analytics rules
    });

    const query = Qs.parse(window.location.search.substring(1));

    if (response.data && response.data.user && response.data.user.roles) {
      const roles = response.data.user.roles;
      if (roles.admin) {
        Actions.redirectBasedOnAdminCreds();
      } else {
        if (query.returnUrl && ApiActions.validateReturnURL(query.returnUrl)) {
          window.location.href = query.returnUrl;
        } else {
          window.location.href = "/account";
        }
      }
    }
  }

  static async logout() {

    await ApiActions.delete(
      '/v1/logout',
      undefined,
      LogoutStore,
      Constants.LOGOUT,
      Constants.LOGOUT_RESPONSE
    );
    //reset nav bar store so login state resets
    setTimeout(function(){
      NavBarStore.dispatch({ type: NavBarConstants.RESET_STORE });
    }, 1);
  }

  static reset(data) {

    ApiActions.post(
      '/v1/login/reset',
      data,
      ResetStore,
      Constants.RESET,
      Constants.RESET_RESPONSE
    );
  }

  static confirmEmail(data) {
    ApiActions.post(
      '/v1/login/confirmEmail',
      data,
      ConfirmStore,
      Constants.CONFIRM,
      Constants.CONFIRM_RESPONSE
    );
  }

  static resetStore() {

    ForgotStore.dispatch({ type: Constants.RESET_STORE });
    LoginStore.dispatch({ type: Constants.RESET_STORE });
    LogoutStore.dispatch({ type: Constants.RESET_STORE });
    ResetStore.dispatch({ type: Constants.RESET_STORE });
    ConfirmStore.dispatch({ type: Constants.RESET_STORE });
    NavBarStore.dispatch({ type: NavBarConstants.RESET_STORE });
  }
}


export default Actions;



// WEBPACK FOOTER //
// ./client/pages/main/login/actions.js